import React from 'react';
import { THEME_CONFIG } from '../constants';

const Terms: React.FC = () => {
  return (
    <section id="terms" className="py-12 bg-white dark:bg-gray-950">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white mb-4">Términos y Condiciones de Uso</h1>
          <p className="text-lg text-gray-600 dark:text-gray-300">
            Última actualización: {new Date().toLocaleDateString('es-ES', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>

        <div className="prose dark:prose-invert max-w-none text-gray-700 dark:text-gray-300 space-y-8">
          <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-xl">
            <p className="mb-0">
              Al acceder y utilizar este sitio web, usted acepta los siguientes términos y condiciones de uso. Le rogamos que los lea atentamente.
            </p>
          </div>

          <div className="space-y-6">
            <h2 className="text-2xl font-bold text-secondary dark:text-white">1. Objeto</h2>
            <p>
              Las presentes condiciones generales de uso regulan el acceso y la utilización del sitio web de {THEME_CONFIG.clinicName}, incluyendo los contenidos y servicios puestos a disposición de los usuarios en y/o a través del sitio web.
            </p>

            <h2 className="text-2xl font-bold text-secondary dark:text-white">2. Condiciones de Acceso y Uso</h2>
            <div className="space-y-4 ml-4">
              <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200">2.1 Usuarios</h3>
              <p>
                El acceso y/o uso de este portal de {THEME_CONFIG.clinicName} atribuye la condición de USUARIO, que acepta, desde dicho acceso y/o uso, las presentes condiciones de uso.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200">2.2 Uso del Portal</h3>
              <p>
                El usuario se compromete a utilizar el portal y sus servicios de conformidad con la ley, la moral, las buenas costumbres y el orden público. Asimismo, el usuario se compromete a no utilizar el portal con fines o efectos ilícitos o contrarios al contenido de las presentes condiciones generales de uso.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-secondary dark:text-white">3. Servicios</h2>
            <div className="space-y-4 ml-4">
              <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200">3.1 Servicios de Salud</h3>
              <p>
                {THEME_CONFIG.clinicName} ofrece servicios médicos a través de sus profesionales debidamente cualificados. La información proporcionada en este sitio web no sustituye el consejo médico profesional.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200">3.2 Citas en Línea</h3>
              <p>
                El sistema de citas en línea está sujeto a disponibilidad. La confirmación de la cita está sujeta a la disponibilidad real en el momento de procesar la solicitud.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-secondary dark:text-white">4. Responsabilidades</h2>
            <div className="space-y-4 ml-4">
              <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200">4.1 Del Usuario</h3>
              <p>
                El usuario será responsable de las infracciones en que incurra o de los perjuicios que cause por el uso del portal, quedando {THEME_CONFIG.clinicName} exonerado de cualquier responsabilidad.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200">4.2 Del Portal</h3>
              <p>
                {THEME_CONFIG.clinicName} no garantiza la disponibilidad y continuidad del funcionamiento del portal y de los servicios. Cuando sea razonablemente posible, se advertirá previamente de las interrupciones en el funcionamiento del portal y de los servicios.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-secondary dark:text-white">5. Política de Privacidad</h2>
            <p>
              Los datos personales proporcionados a través del portal serán tratados de acuerdo con lo establecido en nuestra Política de Privacidad, que forma parte integrante de las presentes condiciones generales.
            </p>

            <h2 className="text-2xl font-bold text-secondary dark:text-white">6. Legislación Aplicable</h2>
            <p>
              Las presentes condiciones se regirán por la legislación española. Para cualquier controversia que pudiera derivarse se someterán a los Juzgados y Tribunales de [Ciudad], con renuncia expresa de cualquier otro fuero que pudiera corresponderles.
            </p>

            <div className="bg-blue-50 dark:bg-blue-900/30 p-6 rounded-xl border-l-4 border-primary">
              <h3 className="text-xl font-semibold text-primary dark:text-primary-300 mb-2">Contacto</h3>
              <p className="mb-0">
                Si tiene cualquier duda sobre estos términos y condiciones, puede contactar con nosotros a través de [email de contacto] o en la dirección [dirección física].
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Terms;